import {
  GKClientDataGrid,
  Grid2,
  Show,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "components";
import dayjs from "dayjs";
import { useFetchQuery } from "hooks/useQueries";
import { SingleModelPortfolioRebalncesInterface } from "interfaces/EquityBasket";
import { isEmpty } from "lodash";
import { useParams } from "react-router-dom";
import { useAppSelector } from "store/store";
import { extraColumnsField, matchDate } from "utils/helpers";

const ViewRebalanceTab = () => {
  const { id } = useParams();

  const { selectedBasket: data } = useAppSelector(
    (state) => state?.equityBasket,
  );

  const { data: listOfRebalance, isFetching } = useFetchQuery<{
    data: { data: SingleModelPortfolioRebalncesInterface[] };
  }>({
    key: ["GET_REBALANCES"],
    route: `/model_portfolio/${id}/version/rebalance_list/?is_draft=false`,
  });

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <Typography variant="primaryDark">
          {" "}
          {data?.basketType === "Asset" ? "Recommendation" : "Rebalance"}{" "}
          Schedule
        </Typography>
      </Grid2>
      <Show.When
        isTrue={
          !isEmpty(data?.rebalanceTime) ||
          !isEmpty(data?.lastRebalanceDate) ||
          !isEmpty(data?.nextRebalanceDate)
        }
        showNodata
      >
        <Grid2 size={7}>
          <TableContainer sx={{ border: "none" }}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    style={{
                      backgroundColor: "#F8F8F8",
                      padding: 24,
                    }}
                  >
                    <Typography color="#697586" fontSize={12}>
                      {data?.basketType === "Asset"
                        ? "Recommendation"
                        : "Rebalance"}{" "}
                      Frequency
                    </Typography>
                    <Typography>{data?.rebalanceTime || "N/A"}</Typography>
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: "#F8F8F8",
                      padding: 24,
                    }}
                  >
                    <Typography color="#697586" fontSize={12}>
                      Last{" "}
                      {data?.basketType === "Asset"
                        ? "Recommendation"
                        : "Rebalance"}{" "}
                      Date
                    </Typography>
                    <Typography>
                      {matchDate(data?.lastRebalanceDate) || "N/A"}
                    </Typography>
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: "#F8F8F8",
                      padding: 24,
                    }}
                  >
                    <Typography color="#697586" fontSize={12}>
                      Next{" "}
                      {data?.basketType === "Asset"
                        ? "Recommendation"
                        : "Rebalance"}{" "}
                      Date
                    </Typography>
                    <Typography>
                      {matchDate(data?.nextRebalanceDate) || "N/A"}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid2>
      </Show.When>
      <Grid2 size={12}>
        {data?.basketType === "Asset" ? (
          <Typography color="#4F4F4F" fontSize={12}>
            There have been <b>{data?.rebalanceCount}</b> recommendations since
            creation date.
          </Typography>
        ) : (
          <Typography color="#4F4F4F" fontSize={12}>
            This portfolio is rebalanced <b>{data?.rebalanceCount}</b> times
            since Creation Date: <b>{data?.basketCreationDate}</b>
          </Typography>
        )}
      </Grid2>
      <Show.When isTrue={data?.basketType !== "Asset"}>
        <Grid2 size={12}>
          <Typography variant="primaryLight">Rebalance history</Typography>
        </Grid2>
        <Grid2 size={7}>
          <GKClientDataGrid
            loading={isFetching}
            density="compact"
            rows={listOfRebalance?.data?.data || []}
            columns={[
              { ...extraColumnsField("Date", "date", 1, 1) },
              { ...extraColumnsField("Version Name", "name", 1, 1) },
              {
                ...extraColumnsField(
                  "Days since rebalance",
                  "DaysSinceRebalance",
                  1,
                  1,
                ),
                type: "number",
                renderCell: (params) => {
                  const { date } = params?.row;
                  const today = dayjs();
                  const daysDiff = today.diff(date, "day");

                  return <Typography>{daysDiff}</Typography>;
                },
              },
            ]}
            name="rebalancesTable"
          />
        </Grid2>
      </Show.When>
    </Grid2>
  );
};

export default ViewRebalanceTab;
